import * as React from "react";
type Props = {
  className?: string,
};
function SvgOrganic({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Organic"
      className={className}
    >
      <path
        d="M20.0001 27.1723V35M20.0001 27.6901C0.253878 27.8972 2.19524 7.85718 2.19524 7.85718C21.9127 8.6706 20.0001 27.6901 20.0001 27.6901ZM20.0001 27.7342C39.7464 27.9412 37.8047 7.90195 37.8047 7.90195C18.1878 8.671 20.1009 27.6901 20.1009 27.6901L20.0001 27.7342Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgOrganic;
